<template>
  <v-card>
    <v-toolbar :color="color ? color : 'primary'" dark min-height="85px" style="padding-top:10px;" :style="{'opacity': color ? '0.7' : '1'}">
      <v-icon v-if="icon" style="margin-right:10px">{{ icon }}</v-icon>
      <v-toolbar-title>{{ $t(title) }}</v-toolbar-title>
      <v-spacer /><v-spacer /><v-spacer /><v-spacer />
      <v-text-field
        v-if="onSearch"
        v-model="search"
        append-icon="mdi-search"
        :label="$t('common.search')"
        hideDetails
        outlined
        @input="handleSearch"
        style="margin-right:20px"
      />
      <v-btn
        v-if="onAdd"
        class="mx-2" fab dark small :color="color?color:'primary'"
        @click="onAdd"
      >
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </v-toolbar>
    <!-- <v-card-title>
      <v-spacer></v-spacer>
      <v-text-field
        v-if="onSearch"
        v-model="search"
        append-icon="mdi-search"
        :label="$t('common.search')"
        singleLine
        hideDetails
        @input="handleSearch"
      ></v-text-field>
    </v-card-title> -->
    <!-- <v-data-table
      :loading="isLoading"
      loadingText="Loading... Please wait"
      :headers="headers"
      :items="items"
      :search="search"
      hideDefaultFooter
    > -->
     <v-data-table
      :loading="isLoading"
      loadingText="Loading... Please wait"
      :headers="headers"
      :items="items"
      :itemsPerPage="itemsPerPage"
      hideDefaultFooter
      v-bind:class="isWelcomeModal ? 'welcome-modal' : null"
      single-expand
      item-key="ID"
      :expanded.sync="expanded"
      :showExpand="isWelcomeModal"
    >
      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length">
          <stats-welcome-modal
            :id="item.ID"
          />
        </td>
      </template>
      <template v-slot:item.ident="{ item }">
        <a 
          v-if="item.ident.onClick"
          @click.stop.prevent="item.ident.onClick(item.ident.id)"
        >
          {{ item.ident.name}}
        </a>
        <a
          v-else
          @click.stop.prevent="handleGoTo(item.ident.id)"
        >
          {{ item.ident.name}}
        </a>
      </template>
      <v-divider vertical />
      <template v-slot:item.actions="{ item }">
        <a
          @click.stop.prevent="handleGoTo(`common-menus/${item.ident.id}`)"
        >
          {{$t('enterprises.linkCommon')}}
        </a>
        <span style="margin: 20px 0;">|</span>
        <a
          @click.stop.prevent="handleEditMenus(item)"          
        >
          {{$t('enterprises.editMenus')}}
        </a>
      </template>
      <template v-slot:item.log="{ item }">
        <p style="margin-bottom: 0px;">{{prepareDate(item.log.cd, true)}}</p>
        <p>{{prepareDate(item.log.lmd)}}</p>
      </template>
      <template v-slot:item.preview="{ item }">
        <custom-modal :previewData="previewData" v-if="item.index === 0"/>
        <a
          v-for="locale of languages"
          style="margin: 0 10px"
          @click="handleClickPreview(locale, item.previewURL, item.ident.id)"
        >
          {{locale.toUpperCase()}}
        </a>
      </template>
      <template v-slot:item.hide="{ item }">
        <a 
          @click="handleHideWelcomeModal(item)">
          <v-icon :color="!item.hide ? 'green' : 'red'">mdi-eye</v-icon>
        </a>
      </template>
      <template v-slot:item.remember="{ item }">
        <a 
          @click="handleRememberWelcomeModal(item)">
          <v-icon>{{ item.remember ? 'mdi-checkbox-outline' : 'mdi-checkbox-blank-outline' }}</v-icon>
        </a>
      </template>
    </v-data-table>
    <div
      v-if="pageCount > 1"
      class="text-center pt-2"
    >
      <v-pagination
        v-model="page"
        :length="pageCount"
        @input="handleChangePage"
        :color="color?color:'primary'"
      />
    </div>
  </v-card>
</template>

<script>
  import _ from 'lodash'
  import api from '@/services/api'
  import utils from '@/services/utils'
  import CustomModal from '@/components/customModal/Index'
  import StatsWelcomeModal from '@/views/private/settings/formWelcomeModal/StatsWelcomeModal'
  export default {
    components: {
      CustomModal,
      StatsWelcomeModal,
    },
    props: {
      title: {
        type: String,
        required: false,
        default: null
      },
      icon: {
        type: String,
        required: false,
        default: null
      },
      headers: {
        type: Array,
        requerido: true
      },
      data: {
        type: Array,
        requerido: true
      },
      count: {
        type: Number,
        requerido: true
      },
      loading: {
        type: Boolean,
        requerido: false,
        default: false
      },
      onAdd: {
        type: Function,
        required: false
      },
      onSearch: {
        type: Function,
        required: false
      },
      color: {
        type: String,
        required: false,
        default: null
      },
      isWelcomeModal: {
        type: Boolean,
        default: false,
      },
      itemsPerPage: {
        type: Number,
        default: 10,
      },
    },
    data () {
      return {
        items: this.data,
        search: '',
        isLoading: this.loading,
        page: 1,
        previewData: null,
        expanded: null,
        selectedWelcomeModalID:null,
      }
    },
    computed: {
      languages () {
        return this.$store.state.app.Languages
      },
      pageCount () {
        let page = this.count > 0 ? parseInt(this.count / this.itemsPerPage, 10) : 0
        if (this.count > 0 && (this.count % this.itemsPerPage)!== 0) page++
        return page
      },
    },
    watch: {
      data: {
        handler: function (newValue) {
          this.items = newValue
        },
        deep: true
      },
      expanded () {
        /*
        console.log('jjjj', this.expanded)
        if (!this.isWelcomeModal || !this.expanded) return
        const aux = this.expanded.shift()
        if (!aux) return 
        this.selectedWelcomeModalID = aux.ID
        */
      },
    },
    created () {
      this.items = this.data
      this.handleSearch = _.debounce(() => {
        this.onSearch(this.search)
      }, 500)
    },
    methods: {
      prepareDate (v, isCD) {
        if(!v) return ''

        const aux = isCD ? 'Creado: ' : 'Modificado: '
        return `${aux}${v.split('T').join(' ').split('.').shift()}`
      },
      handleGoTo (id) {
        this.$router.push(`${this.$route.path}/${id}`)
      },
      handleChangePage () {
        this.onSearch(this.search, this.page)
      },
      handleEditMenus (value) {
        api.getItem('enterprises', true, value.ident.id).then(response => {
          utils.setActiveEnterprise(this, response)
          this.$router.push('/menus')
        })
      },
      handleClickPreview (locale, url, id) {
        //window.open(url.concat('&locale=', locale), '_blank')
        this.previewData = {
          locale,
          id,
          lmd: new Date().getTime()
        }
      },
      handleHideWelcomeModal (v) {
        v.hide = !v.hide
        api.updateItem('enterprises/welcome-modal', v.ident.id.concat('/hide'), v).then(response => {
          console.log('jj', response)
        })
      },
      handleRememberWelcomeModal (v) {
        v.remember = !v.remember
        api.updateItem('enterprises/welcome-modal', v.ident.id.concat('/remember'), v).then(response => {
          console.log('jj', response)
        })
      },

    }
  }
</script>
<style>
.welcome-modal tr td{
  padding-top: 15px !important;
}
</style>
